module.exports = __webpack_public_path__ + "cdb87360bd1127b56706d946f692421f.png";